<template>
    <div class='index'>

        <router-view></router-view>
      <Bar />
    </div>
</template>
<script>
import Bar from '@/components/bar/bar'

export default {
    components:{
        Bar
    }, mounted() {

		this.sandMate();

		},methods: {

	sandMate(){



		if(window.localStorage.getItem('user')== ""||!window.localStorage.hasOwnProperty('user')){
			// location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx9ea0e5b6f66b974a&redirect_uri=https%3a%2f%2fxcx.ylhwlkj.com%2f%23%2fkin%2f&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'
      location.href='https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxa3cf5f36ec8d12b4&redirect_uri=https%3a%2f%2fdyp.ylhwlkj.com%2f%23%2fkin%2f&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect'

		}
	}


			 }
}
</script>
